import React from 'react';
import './FlameVideo.css';

export default function FlameVideo({ className = '', height = 32 }) {
  return (
    <video
      className={`flame-video ${className}`}
      style={{ height }}
      src="/logo-flame.mp4"
      autoPlay loop muted playsInline
      aria-hidden="true"
    />
  );
}
